module.exports = __webpack_public_path__ + "static/media/about8.c3fbb20d.webp";